<template>
  <el-container class="layout-container">
    <!-- 侧边导航栏 -->
    <el-aside width="200px" class="sidebar">
      <div class="logo">SD Tags管理系统</div>
      <el-menu 
        :default-active="$route.path" 
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        @select="handleMenuSelect">
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/works">
          <i class="el-icon-folder"></i>
          <span slot="title">作品管理</span>
        </el-menu-item>
        <el-menu-item index="/roles">
          <i class="el-icon-user"></i>
          <span slot="title">角色管理</span>
        </el-menu-item>
        <el-menu-item index="/tags">
          <i class="el-icon-tags"></i>
          <span slot="title">标签管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <!-- 主内容区 -->
    <el-container>
      <el-header class="header">
        <div class="header-content">
          <!-- <div class="search-container">
            <el-input 
              v-model="searchKeyword" 
              placeholder="搜索作品或角色..." 
              class="search-input"
              @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </div> -->
          <div class="user-info">
            <span>{{ userName }}</span>
            <el-button type="text" @click="logout">退出</el-button>
          </div>
        </div>
      </el-header>
      
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'LayoutView',
  data() {
    return {
      searchKeyword: ''
    };
  },
  computed: {
    ...mapState([
      'userName'
    ])
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    handleMenuSelect(index) {
      // 确保导航点击正确跳转到对应路由
      this.$router.push(index);
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        // 根据当前路由决定搜索类型
        if (this.$route.path === '/works') {
          this.$router.push({ 
            path: '/works', 
            query: { keyword: this.searchKeyword } 
          });
        } else if (this.$route.path === '/roles') {
          this.$router.push({ 
            path: '/roles', 
            query: { keyword: this.searchKeyword } 
          });
        } else {
          // 默认搜索作品
          this.$router.push({ 
            path: '/works', 
            query: { keyword: this.searchKeyword } 
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.sidebar {
  background-color: #545c64;
  color: white;
}

.logo {
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  border-bottom: 1px solid #677481;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.search-container {
  width: 300px;
}

.search-input {
  width: 100%;
}

.user-info {
  /* display: flex;
  align-items: right; */
  display: flex;
  justify-content: flex-end; /* 子元素靠右对齐 */
  width: 100%; 
}

.user-info span {
  margin-right: 15px;
}

.main-content {
  padding: 20px;
  background-color: #f9f9f9;
}
</style>